// Add your JS customizations here
import Swiper from 'swiper';
import { Autoplay, Navigation, Grid, EffectFade, Pagination } from 'swiper/modules';
import AOS from 'aos';

AOS.init({
	duration: 700,
	once: true
});

// Scroll to top
let contentObserver = new IntersectionObserver(interObsCallback);
contentObserver.observe(document.getElementById('back-top-sentinel'));
let scrollTopBtnWrap = document.querySelector('.scroll-to-top-btn-wrap');
function interObsCallback(entries, observer) {
	entries.forEach((entry) => {
		if(!entry.isIntersecting) {
			scrollTopBtnWrap.classList.remove('is-hidden');
		} else {
			scrollTopBtnWrap.classList.add('is-hidden');
		}
	});
}

// Sticky header
const headerEl = document.querySelector('#site-header');
const sentinalEl = document.querySelector('.header-sentinel');
const handler = (entries) => {
	if (!entries[0].isIntersecting) {
		headerEl.classList.add('is-sticky');
	} else {
		headerEl.classList.remove('is-sticky');
	}
}
const observer = new window.IntersectionObserver(handler);
observer.observe(sentinalEl);

// Header search
jQuery(function($){
	let headerSearchWrap = $('.header-search-wrap');
	let headerSearchIcon = $('.header-search-toggle i');
	$('.header-search-toggle').on('click', function(e){
		e.preventDefault();
		if(headerSearchWrap.hasClass('expanded')) {
			closeSearch();
		} else {
			openSearch();
		}
	});
	function openSearch() {
		headerSearchWrap.addClass('expanded');
		headerSearchIcon.removeClass('fa-search').addClass('fa-xmark');
		setTimeout(function(){
			$('.header-search-keyword').focus();
		}, 250);

	}
	function closeSearch() {
		headerSearchWrap.removeClass('expanded');
		headerSearchIcon.removeClass('fa-xmark').addClass('fa-search');
	}

	$(window).on('click', function() {
		closeSearch();
	});

	$('.header-search-wrap').on('click', function(event){
	  event.stopPropagation();
	});
});


jQuery(function($){
	$('.scroll-to-top').on('click', function(e){
		e.preventDefault();
		document.getElementById("page").scrollIntoView();
	});
	$('.btn-toggle-menu').click(function(e){
		e.preventDefault();
		$(this).toggleClass('mobile-expanded');
		$('.header-main-menu').toggleClass('mobile-expanded');
	});
	$('#main-menu li.menu-item-has-children').append('<button class="toggle-submenu" aria-label="Show sub menu" type="button"><i class="far fa-plus"></i></button>');
	$('#main-menu li').on('click', '.toggle-submenu', function(e){
		e.preventDefault();
		$(this).closest('li').toggleClass('mobile-expanded');
		$(this).siblings('ul').slideToggle(150);
	});

	$('select').selectric({
    maxHeight: 350,
  });

	$('.modal').appendTo('body');

	// Play Vimeo and YouTube videos when modal is opened
	$('.modal').on('shown.bs.modal', function () {
		let iframe = $(this).find('iframe')[0];

		if (iframe.contentWindow) {
			// Play Youtube
			if (iframe.src.startsWith("https://www.youtube.com")) {
				iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
			}
			// Play Vimeo
			if (iframe.src.startsWith("https://player.vimeo.com/")) {
				iframe.contentWindow.postMessage('{"method":"play"}', "*");
			}
		}
	});
	
	// Pause Vimeo and YouTube videos when modal is closed
	$('.modal').on('hidden.bs.modal', function () {
		let iframe = $(this).find('iframe')[0];

		if (iframe.contentWindow) {
			// Pause Youtube
			if (iframe.src.startsWith("https://www.youtube.com")) {
				iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
			}
			// Pause Vimeo
			if (iframe.src.startsWith("https://player.vimeo.com/")) {
				iframe.contentWindow.postMessage('{"method":"pause"}', "*");
			}
		}
	});
	
	$('.full-width-bg-block').each(function(index, el){
		if($(el).next().hasClass('full-width-bg-block')) {
			$(el).addClass('block-margin-fix');
		}
	});

	$('.toggle-hero-filter').on('click', function(){
		$('.hero-filter').slideToggle(100);
		$('.hero-listing').toggleClass('mobile-expanded');
		$(this).find('i').toggleClass('fa-plus fa-xmark');
	});

	$('.svg-inline').each(function() {
		var $img = $(this),
		imgURL = $img.attr('src'),
		imgID  = $img.attr('id');

		$.get(imgURL, function(data) {
			var $svg = $(data).find('svg');
			if(typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}
			$svg = $svg.removeAttr('xmlns:a');
			$img.replaceWith($svg);
		}, 'xml');
	});

});

// Ajax functions
jQuery(function($){

	// Load more ajax master function
	function loadMoreAjax(btn, ajaxData) {
		let thisBtnWrap = btn.closest('.load-more-btn-wrap');
		let holder = thisBtnWrap.siblings('.ajax-holder');

		thisBtnWrap.addClass('loading');
		thisBtnWrap.append(`
			<div class="spinner-wrap">
			<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Loading...</span>
			</div>
			</div>
		`);

		$.ajax({
			type: "post",
			url: local_var.ajax_url,
			data: ajaxData,
			success: function(response){
				thisBtnWrap.remove();
				let output = $('<div class="output"></div>').append($.parseHTML(response));
				let dataButton = $(output).find('.load-more-btn-wrap');
				let entries = $(output).find('.data-wrap');
				holder.append($(entries).html());
				if(dataButton.length) {
					dataButton.insertAfter(holder);
				}
			}
		});
	}

	// Leadership Landing Load more
	$('.leadership-listing').on('click', '.more-people-btn', function(e){
		e.preventDefault();
		let $this = $(this);
		let ajaxData = {
			action: 'more_members',
			nonce: local_var.nonce,
			slug: $this.data('slug'),
			offset: $this.data('offset'),
			order: $this.data('order'),
			ppp: $this.data('ppp'),
			keyword: $this.data('keyword'),
		}
		loadMoreAjax($this, ajaxData);
	});

	// Related Projects load more
	$('.related-projects-listing').on('click', '.load-more-btn-wrap .btn', function(e){
		e.preventDefault();
		let $this = $(this);
		let ajaxData = {
			action: 'more_related_projects',
			nonce: local_var.nonce,
			pid: $this.data('pid'),
			offset: $this.data('offset'),
			ppp: $this.data('ppp'),
		}
		loadMoreAjax($this, ajaxData);
	});

	// Related leadership team load more
	$('.related-members-ajax-wrap').on('click', '.load-more-btn-wrap .btn', function(e){
		e.preventDefault();
		let $this = $(this);
		let ajaxData = {
			action: 'more_related_members',
			nonce: local_var.nonce,
			pid: $this.data('pid'),
			offset: $this.data('offset'),
			ppp: $this.data('ppp'),
		}
		loadMoreAjax($this, ajaxData);
	});

	// Mobile news load more
	$('.blog-posts-listing').on('click', '.mobile-news-more-btn-wrap .btn', function(e){
		e.preventDefault();
		let $this = $(this);
		let ajaxData = {
			action: 'more_news_mob',
			nonce: local_var.nonce,
			cat: $this.data('cat'),
			keyword: $this.data('keyword'),
			offset: $this.data('offset'),
		}
		loadMoreAjax($this, ajaxData);
	});

	// Related projects by markket
	$('.related-market-projects-ajax').on('click', '.load-more-btn-wrap .btn', function(e){
		e.preventDefault();
		let $this = $(this);
		let ajaxData = {
			action: 'more_rm_project',
			nonce: local_var.nonce,
			pid: $this.data('pid'),
			offset: $this.data('offset'),
			ppp: $this.data('ppp'),
			slug: $this.data('slug'),
		}
		loadMoreAjax($this, ajaxData);
	});


	// Filters
	$('.ajax-form-filter select:not(#filter-market)').on('change', function(e){
		$(this).closest('form').submit();
	});

	$('.hero-listing .clear-filter').on('click', function(e) {
		e.preventDefault();
		$('#filter-col-type').hide();
		$('.hero-projects-filter').addClass('two-cols');
		$('.ajax-form-filter input').val('');
		$('.ajax-form-filter select').prop('selectedIndex', 0).selectric('refresh');
		$('.ajax-form-filter').submit();

	});

	// Projects landing: update project category options by market
	$('#filter-market').on('change', function(e){
		let $this = $(this);
		let termId = $(this).val();
		$('#filter-project-category option:not(:first-child)').remove().selectric();
		$('#filter-project-category').prop('selectedIndex', 0).selectric('refresh');
		if(!$(this).val()) {
			$('.hero-filter').addClass('two-cols');
			$('#filter-col-type').hide();
			$this.selectric();
		} else {
			$.ajax({
				type: "post",
				url: local_var.ajax_url,
				data: {
					action: 'update_types',
					nonce: local_var.nonce,
					termid: termId,
				},
				success: function(response){
					if(response) {
						$('#filter-project-category').append(response).selectric();
						$('.hero-filter').removeClass('two-cols');
						$('#filter-col-type').show();
						$this.selectric();
					} else {
						$('.hero-filter').addClass('two-cols');
						$('#filter-col-type').hide();
						$this.selectric();
					}
				}
			});
		}
		$('.ajax-form-filter').submit();
	});

	$('.ajax-form-filter').on('submit', function(e){
		e.preventDefault();
		let target = $(this).attr('action') + '?' + $(this).serialize();
		let holderSelector = '.ajax-filter-wrap';
		let holder = $(holderSelector);

		holder.addClass('loading');
		holder.append(`
			<div class="spinner-wrap">
			<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Loading...</span>
			</div>
			</div>
		`);

		$('.hero-filter').slideUp(100);
		$('.hero-listing').removeClass('mobile-expanded');
		$('.toggle-hero-filter i').toggleClass('fa-plus fa-xmark');

		let isFiltered = false;
		$('.ajax-form-filter input, .ajax-form-filter select').each(function(){
			if($(this).val()) {
				isFiltered = true;
			}
		});

		if(isFiltered) {
			$('.ajax-form-filter .filter-clear').addClass('show-filter-clear');
		} else {
			$('.ajax-form-filter .filter-clear').removeClass('show-filter-clear');
		}

		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.empty().removeClass('loading').append(entries);
		});
	});

	// Load more ajax global
	$('.ajax-filter-wrap').on('click', '.ajax-more-wrap a', function(e){
		e.preventDefault();
		let target = $(this).attr('href');
		let thisBtnWrap = $(this).closest('.ajax-more-wrap');
		let holderSelector = '.ajax-holder';
		let holder = $(holderSelector);

		thisBtnWrap.addClass('loading');
		thisBtnWrap.append(`
			<div class="spinner-wrap">
			<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Loading...</span>
			</div>
			</div>
		`);

		$.get(target, function(response){
			let entries = $(response).find(holderSelector).children();
			holder.append(entries);
			thisBtnWrap.remove();
			let generatedBtnWrap = $(response).find('.ajax-more-wrap');
			if(generatedBtnWrap.length) {
				generatedBtnWrap.insertAfter(holder);
			}
		});

	});

});


const heroSlider = new Swiper('.hero-slider .swiper', {
	loop: true,
	effect: 'fade',
	modules: [ Navigation, EffectFade, Autoplay ],
	speed: 700,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
		waitForTransition: false,
	}
});


const projectSliderDesktop = document.querySelectorAll('.projects-carousel-desktop');
projectSliderDesktop.forEach(wrapper => {
	let navWrap = wrapper.closest('.featured-projects-carousel').querySelector('.swiper-nav-btn-wrap.btns-desktop');
	
	// According to the Swiper.js docs: "Because of nature of how the loop mode works (it will rearrange slides), total number of slides must be >= slidesPerView * 2"
	// So, make sure we have enough slides. If not, duplicate the existing slides until we do.
	if( wrapper.querySelectorAll('.swiper-slide').length ){
		while( wrapper.querySelectorAll('.swiper-slide').length <= 2 ){
			wrapper.querySelectorAll('.swiper-slide').forEach( slide => {
				wrapper.querySelector('.swiper-wrapper').appendChild( slide.cloneNode(true) );
			});
		}
	}
	
	let startingPosition = Math.floor(Math.random() * (wrapper.querySelectorAll('.swiper-slide').length)) - 1;
	
	const featuredProjectSlider = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		modules: [ Navigation ],
		speed: 800,
		slidesPerView: 1,
		spaceBetween: 26,
		centeredSlides: true,
		initialSlide: startingPosition,
		navigation: {
			nextEl: navWrap.querySelector('.swiper-button-next'),
			prevEl: navWrap.querySelector('.swiper-button-prev'),
		},
		breakpoints: {
			1024: {
				spaceBetween: 40,
				slidesPerView: 1.01,
			}
		}
	});
});

const projectSliderPhone = document.querySelectorAll('.projects-carousel-phone');
projectSliderPhone.forEach(wrapper => {
	let navWrap = wrapper.closest('.featured-projects-carousel').querySelector('.swiper-nav-btn-wrap.btns-phone');
	
	// According to the Swiper.js docs: "Because of nature of how the loop mode works (it will rearrange slides), total number of slides must be >= slidesPerView * 2"
	// So, make sure we have enough slides. If not, duplicate the existing slides until we do.
	if( wrapper.querySelectorAll('.swiper-slide').length ){
		while( wrapper.querySelectorAll('.swiper-slide').length <= 2 ){
			wrapper.querySelectorAll('.swiper-slide').forEach( slide => {
				wrapper.querySelector('.swiper-wrapper').appendChild( slide.cloneNode(true) );
			});
		}
	}
	
	let startingPosition = Math.floor(Math.random() * (wrapper.querySelectorAll('.swiper-slide').length)) - 1;
	
	const featuredProjectSlider = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		modules: [ Navigation ],
		speed: 800,
		slidesPerView: 1,
		spaceBetween: 26,
		centeredSlides: true,
		initialSlide: startingPosition,
		navigation: {
			nextEl: navWrap.querySelector('.swiper-button-next'),
			prevEl: navWrap.querySelector('.swiper-button-prev'),
		},
	});
});




const photoSliderWrap = document.querySelectorAll('.photo-slider');
photoSliderWrap.forEach(wrapper => {
	const photoSwiper = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		effect: 'fade',
		modules: [ Navigation, EffectFade, Autoplay ],
		speed: 700,
		navigation: {
			nextEl: wrapper.querySelector('.swiper-button-next'),
			prevEl: wrapper.querySelector('.swiper-button-prev'),
		},
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
			waitForTransition: false,
		}
	});

	const pauseBtn = wrapper.querySelector('.swiper-control-button');
	if(pauseBtn) {
		pauseBtn.addEventListener('click', function(){
			if(this.classList.contains('paused')) {
				photoSwiper.autoplay.start();
				this.classList.remove('paused');
			} else {
				photoSwiper.autoplay.stop();
				this.classList.add('paused');
			}
		});
	}

});


const inquiriesSliderWrap = document.querySelectorAll('.inquiries-contact-slider');
inquiriesSliderWrap.forEach(wrapper => {
	const graySwiper = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		modules: [ Navigation, Pagination, Autoplay ],
		speed: 500,
		spaceBetween: 40,
		pagination: {
			el: wrapper.querySelector('.swiper-pagination'),
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span>' +
				'/' +
				'<span class="' + totalClass + '"></span>';
				}
		  },
		navigation: {
			nextEl: wrapper.querySelector('.swiper-button-next'),
			prevEl: wrapper.querySelector('.swiper-button-prev'),
		},
    autoplay: {
			delay: 4000,
			disableOnInteraction: false,
			waitForTransition: false,
		}
	});
  
  const pauseBtn = wrapper.querySelector('.swiper-control-button');
	if(pauseBtn) {
		pauseBtn.addEventListener('click', function(){
			if(this.classList.contains('paused')) {
				graySwiper.autoplay.start();
				this.classList.remove('paused');
			} else {
				graySwiper.autoplay.stop();
				this.classList.add('paused');
			}
		});
	}

});

const relatedNewsSliderWrap = document.querySelectorAll('.related-news-slider');
relatedNewsSliderWrap.forEach(wrapper => {
	const graySwiper = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		modules: [ Autoplay, Navigation, Pagination ],
		speed: 500,
		spaceBetween: 40,
		pagination: {
			el: wrapper.querySelector('.swiper-pagination'),
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span>' +
				'/' +
				'<span class="' + totalClass + '"></span>';
			}
		},
		autoplay: {
			delay: 8000,
			disableOnInteraction: false,
			waitForTransition: false,
		},
		navigation: {
			nextEl: wrapper.querySelector('.swiper-button-next'),
			prevEl: wrapper.querySelector('.swiper-button-prev'),
		}
	});

});

const testimonialSliderWrap = document.querySelectorAll('.testimonials-slider');
testimonialSliderWrap.forEach(wrapper => {
	const testimonialSwiper = new Swiper(wrapper.querySelector('.swiper'), {
		loop: true,
		modules: [ Navigation, Pagination ],
		speed: 500,
		pagination: {
			el: wrapper.querySelector('.swiper-pagination'),
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span>' +
				'/' +
				'<span class="' + totalClass + '"></span>';
				}
		  },
		navigation: {
			nextEl: wrapper.querySelector('.swiper-button-next'),
			prevEl: wrapper.querySelector('.swiper-button-prev'),
		}
	});

});

// 100 viewport width fix
function setVw() {
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
setVw();
window.addEventListener('resize', setVw);
